/** When chapter has no examQuestionCount in JSON. */
export const DEFAULT_EXAM_QUESTION_COUNT = 5;
